import { render, staticRenderFns } from "./Paymentmethod.vue?vue&type=template&id=08ba28eb&scoped=true&"
import script from "./Paymentmethod.vue?vue&type=script&lang=js&"
export * from "./Paymentmethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba28eb",
  null
  
)

export default component.exports